import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import Products from "./pages/Products";
import DevelopmentModels from "./pages/DevelopmentModels";
import Stamps from "./pages/Stamps";
import Contact from "./pages/Contact";
import Header from "./components/Header";
import Footer from "./components/Footer";
import { Toaster } from "./components/Toaster";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/azienda" element={<About />} />
            <Route path="/fustelle" element={<Products />} />
            <Route path="/sviluppo-modelli" element={<DevelopmentModels />} />
            <Route path="/timbri" element={<Stamps />} />
            <Route path="/contatti" element={<Contact />} />
          </Routes>
        </main>
        <Footer />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;